export enum ShipmentEventType {
  PICK_UP_ARRIVE = 'PICK_UP_ARRIVE',
  CARRIER_PICKED_UP = 'CARRIER_PICKED_UP',
  PICK_UP_DEPART = 'PICK_UP_DEPART',
  PICK_UP_LOAD = 'PICK_UP_LOAD',
  IN_TRANSIT = 'IN_TRANSIT',
  CARRIER_LOCATION_UPDATE = 'CARRIER_LOCATION_UPDATE',
  TERMINAL_ARRIVE = 'TERMINAL_ARRIVE',
  TERMINAL_AT_STOP = 'TERMINAL_AT_STOP',
  TERMINAL_DEPART = 'TERMINAL_DEPART',
  DROPOFF_ARRIVE = 'DROPOFF_ARRIVE',
  DROPOFF = 'DROPOFF',
  DROPOFF_DEPART = 'DROPOFF_DEPART',
  DROPOFF_UNLOAD = 'DROPOFF_UNLOAD',
  SHIPPER_OBSERVED_CARRIER_PICKUP = 'SHIPPER_OBSERVED_CARRIER_PICKUP',
  CONSIGNEE_OBSERVED_CARRIER_DROPOFF = 'CONSIGNEE_OBSERVED_CARRIER_DROPOFF',
  APPOINTMENT_REQUESTED = 'APPOINTMENT_REQUESTED',
  APPOINTMENT_CREATED = 'APPOINTMENT_CREATED',
  APPOINTMENT_CONFIRMED = 'APPOINTMENT_CONFIRMED',
  APPOINTMENT_LOAD_REJECTED = 'APPOINTMENT_LOAD_REJECTED',
  APPOINTMENT_CHECKED_IN = 'APPOINTMENT_CHECKED_IN',
  APPOINTMENT_CHECKED_OUT = 'APPOINTMENT_CHECKED_OUT',
  APPOINTMENT_ETA_UPDATED = 'APPOINTMENT_ETA_UPDATED',
  APPOINTMENT_RESCHEDULED = 'APPOINTMENT_RESCHEDULED',
  APPOINTMENT_CANCELLED = 'APPOINTMENT_CANCELLED',
  INFO = 'INFO',
  UNKNOWN = 'UNKNOWN',
}

export const ShipmentEventMilestones = [
  ShipmentEventType.CARRIER_PICKED_UP,
  ShipmentEventType.DROPOFF,
];

export function isMilestone(shipmentEventType: ShipmentEventType): boolean {
  return ShipmentEventMilestones.includes(shipmentEventType);
}

export const ShipmentOriginEvents = [
  ShipmentEventType.PICK_UP_ARRIVE,
  ShipmentEventType.CARRIER_PICKED_UP,
  ShipmentEventType.PICK_UP_DEPART,
];

export function isShipmentOriginEvent(
  shipmentEventType?: ShipmentEventType,
): boolean {
  return (
    !!shipmentEventType && ShipmentOriginEvents.includes(shipmentEventType)
  );
}

export const ShipmentDeliveryEvents = [
  ShipmentEventType.DROPOFF_ARRIVE,
  ShipmentEventType.DROPOFF,
  ShipmentEventType.DROPOFF_DEPART,
];

export function isShipmentDeliveryEvent(
  shipmentEventType?: ShipmentEventType,
): boolean {
  return (
    !!shipmentEventType && ShipmentDeliveryEvents.includes(shipmentEventType)
  );
}

export const ShipmentMilestoneAssociatedEventTypes = [
  ShipmentEventType.PICK_UP_ARRIVE,
  ShipmentEventType.DROPOFF_ARRIVE,
  ShipmentEventType.PICK_UP_DEPART,
  ShipmentEventType.DROPOFF_DEPART,
];

export const isShipmentMilestoneAssociatedEventType = (
  shipmentEventType?: ShipmentEventType,
): boolean => {
  return (
    !!shipmentEventType &&
    ShipmentMilestoneAssociatedEventTypes.includes(shipmentEventType)
  );
};

export const isPickupOrDropoffType = (
  shipmentEventType?: ShipmentEventType,
): boolean => {
  return (
    isShipmentOriginEvent(shipmentEventType) ||
    isShipmentDeliveryEvent(shipmentEventType)
  );
};
